import { CircleCheck } from "lucide-react";

import { cn } from "@krea/shared/utils";

import { CompanyIndicator } from "./CompanyIndicator";
import { MakeAnotherEstimateButton } from "./MakeAnotherEstimateButton";

/** The likelihood headline box. Mint (filled, no border) for high/very-high, outlined for low. */
export const LikelihoodBox = ({
  title,
  isMint,
  organisationName,
  onGoBack,
  portalContainer,
}: {
  title: string;
  /** High / very-high tier — mint fill + check icon (md+); outlined for low. */
  isMint: boolean;
  organisationName: string;
  onGoBack?: () => void;
  portalContainer?: HTMLElement | null;
}) => {
  return (
    <div
      data-testid="likelihood-box"
      className={cn(
        "flex flex-col items-center gap-1.5 rounded-xl px-4 py-3 mb-5",
        isMint ? "bg-mint-100" : "border border-solid border-primary",
      )}
    >
      <div className="flex items-center gap-3">
        {isMint && (
          <CircleCheck
            data-testid="likelihood-icon"
            // Hidden on mobile, shown from md up.
            className="hidden h-6 w-6 fill-mint-500 text-white outline-mint-500 shrink-0 md:block"
            strokeWidth={2}
            aria-hidden
          />
        )}
        <p className="text-xl font-bold m-0 text-black max-md:text-center">
          {title}
        </p>
      </div>
      <div className="flex items-center gap-1.5">
        <CompanyIndicator organisationName={organisationName} />
        {onGoBack && (
          <MakeAnotherEstimateButton
            onClick={onGoBack}
            portalContainer={portalContainer}
          />
        )}
      </div>
    </div>
  );
};
